/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, {useState, useEffect, useContext} from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  // Switch,
  // useHistory,
} from "react-router-dom";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security, SecureRoute, LoginCallback } from "@okta/okta-react";
import { ErrorBoundary } from 'react-error-boundary';
//import { useNavigate } from "@reach/router";
// import { Container } from "semantic-ui-react";
import config from "./config";
import Dashboard from "./pages/Dashboard";
import Visit from "./pages/Visit";
import NavbarEnlighten from "./ui/Navigation/NavbarEnlighten";

// import AdministrativeActions from './ui/components/footer/AdministrativeActions';
import Home from "./Home";
import HimPage from '../src/ui/components/him/HimPage'
import Ipad from '../src/ui/components/ipad/Ipad'
import CorsErrorModal from "./CorsErrorModal";
import AuthRequiredModal from "./AuthRequiredModal";
import PatientContext from "./context/patientContext";

import { DictionaryContextProvider } from "./context/dictionaryContext";
import { UserPrefContextProvider } from "./context/userPrefContext";
import { CopyUserPrefContextProvider } from "./context/copyUserPrefContext";
import { AuthContextProvider } from "./context/authContext";
import CompanyContext from "./context/companyContext";

// import { VisitWithPrefContextProvider } from "./context/visitWithPrefContext";



// import PatientContext, { PhysContextProvider } from "./context/patientContext";

// const oktaAuth = new OktaAuth(config.oidc);

// const App = () => (
//   <Router>
//     <Security oktaAuth={oktaAuth}>
//       {/* <Navbar /> */}
//       <NavbarEnlighten />
//       <userPreference />
//       <Container text style={{ marginTop: '7em' }}>
//         <Switch>
//           <Route path="/" exact component={Dashboard} />
//           <Route path="/callback" component={LoginCallback} />
//         </Switch>
//       </Container>
//     </Security>
//   </Router>
// );
// export default App;

const oktaAuth = new OktaAuth(config.oidc);

const App = () => {
    const [corsErrorModalOpen, setCorsErrorModalOpen] = React.useState(false);
    const [authRequiredModalOpen, setAuthRequiredModalOpen] = React.useState(false);

    const companyCtx = useContext(CompanyContext);

    //const history = useHistory(); // example from react-router
    const navigate = useNavigate();

    const triggerLogin = async () => {
        await oktaAuth.signInWithRedirect();
    };

    // const blankCompany = {
    //     company_name:'',
    //     company_id: 0,
    // }

    const [mode, setMode] = useState('main')
    const [authMode, setAuthMode] = useState('')
    // const [company, setCompany] = useState(blankCompany)


    const getDictCompanyCode = async () => {

        //console.log("App: companyCtx", companyCtx)


        try {
            const url = `${process.env.REACT_APP_SERVER}/api/v1/dict_services/dict_company_code`
            const response = await fetch(url)

            if (response !== null) {
                const responseData = await response.json()
                // console.log("App.jsx - get company code", responseData)
                let dictCompCode = responseData
                // if autologout and inactivity timeouts are missing use values from env
                if (!!!dictCompCode.auto_logout_minutes) {
                    dictCompCode = {...dictCompCode, auto_logout_minutes: process.env.REACT_APP_AUTO_LOGOUT_MINUTES}
                }
                if (!!!dictCompCode.inactivity_timer_minutes) {
                    dictCompCode = {...dictCompCode, inactivity_timer_minutes: process.env.REACT_APP_INACTIVITY_TIMER_MINUTES}
                }

                // DEBUG ONLY - set inactivity and autologout to short time >>>>>>>>>
                // dictCompCode = {...dictCompCode, auto_logout_minutes: 4, inactivity_timer_minutes: 2}


                // <<<<<<<<  DEBUG


                // fake AD authentication
                // dictCompCode = {...dictCompCode, auth_mode:'DB', id:3, patient_search_mode: 'API'}
                // dictCompCode = {...dictCompCode, auth_mode:'AD', id:4, patient_search_mode: 'API'}
                // companyCtx.setCompany(responseData)
                companyCtx.setCompany(dictCompCode)
                // companyCtx.setCompany({...dictCompCode, inactivity_timer_minutes:null, auto_logout_minutes:null})
                // setCompany({
                //     company_name: responseData.company_name,
                //     company_id: authmode === 'AD' ? 4 :responseData.id,
                // })
                setAuthMode(dictCompCode.auth_mode)
                // setAuthMode(authmode)
                //setAuthMode('OKTA')
            } else {
                console.log("App.jsx - failed to get company code - response", response)
            }
        } catch (e) {
            console.log("App.jsx - failed to get company code - error", e)
        }
    }


    // if auth context is not set - get company code and auth mode
    if (!!!authMode) {
        getDictCompanyCode()
    }

    // useEffect(() => {
    //     const getDictCompanyCode = async () => {
    //         try {
    //             const url = `${process.env.REACT_APP_SERVER}/api/v1/dict_services/dict_company_code`
    //             const response = await fetch(url)

    //             if (response !== null) {
    //                 const responseData = await response.json()
    //                 console.log("App.jsx - get company code", responseData)
    //                 setAuthMode(responseData.auth_mode)
    //                 setAuthMode('OKTA')
    //                 AuthCtx.setAuthMode('OKTA')
    //             } else {
    //                 console.log("App.jsx - failed to get company code - response", response)
    //             }
    //         } catch (e) {
    //             console.log("App.jsx - failed to get company code - error", e)
    //         }
    //     }
    //     if (!!!authMode) {
    //         getDictCompanyCode()
    //     }
    // },[authMode])

    // const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    //   //history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
    // };

    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        //const navigate = useNavigate();
        console.log("App - restoreOriginalUri: originalUri", originalUri, "authMode:", authMode)
        navigate(toRelativeUrl(originalUri || "/", window.location.origin), {state: {authMode: authMode}});
    };

    const customAuthHandler = async () => {
        const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
        console.log("App - customAuthHandler: previousAuthState", previousAuthState)
        if (!previousAuthState || !previousAuthState.isAuthenticated) {
            // App initialization stage
            await triggerLogin();
        } else {
            // Ask the user to trigger the login process during token autoRenew process
            // console.log(oktaAuth);
            setAuthRequiredModalOpen(true);
        }
    };


    

    const handleModeChange = (newMode) => {
        setMode(newMode)
    }

  return (
    // <PatientContext.Provider
    //   value={{
    //     pat_last: (last_name) => {},
    //     pat_first: (first_name) => {},
    //     pat_mrn: (mrn) => {},
    //     pat_gender: (gender) => {},
    //     pat_dob: () => {}
    //   }}
    // >
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={customAuthHandler}
      restoreOriginalUri={restoreOriginalUri}
    >
        <AuthContextProvider>
            <UserPrefContextProvider>
                <CopyUserPrefContextProvider>
                    <DictionaryContextProvider>
                    {/* <VisitWithPrefContextProvider> */}
                    {/* <Navbar {...{ setCorsErrorModalOpen }} /> */}
                    {/* <PatientContext.Provider> */}
                    <ErrorBoundary fallback={<div>Something went wrong </div>}>
                    <NavbarEnlighten /*entity="MEE" site="Main Campus"*/ mode={mode} onModeChange={handleModeChange} /*company={company} */ /*authMode={authMode}*/ />

                        <CorsErrorModal {...{ corsErrorModalOpen, setCorsErrorModalOpen }} />
                        <AuthRequiredModal
                            {...{
                            authRequiredModalOpen,
                            setAuthRequiredModalOpen,
                            triggerLogin,
                            }}
                        />
                        {/* <Container text style={{ marginTop: "7em" }}> */}
                        {/* <Switch> */}
                        <Routes>
                            {/* <Route path="/" exact component={Home} /> */}
                            <Route path="/" exact element={<Home onModeChange={handleModeChange} /*authMode={authMode} company={company}*/ />} />
                            <Route path="/him" exact element={<HimPage onModeChange={handleModeChange}/>} />
                            <Route path="/ipad" exact element={<Ipad onModeChange={handleModeChange}/>} />
                            {/* <Route path="/" exact element={<Home/>} ></Route> */}
                            {/* <Route path="/callback" component={LoginCallback} /> */}
                            <Route path="/callback" element={<LoginCallback />} />
                            {/* <Route path="/callback" element={<Home/>} /> */}
                            {/* <Route path="/dashboard" component={Dashboard} /> */}
                            {/* <Route path="/Visit" component={Visit} /> */}
                            {/* <Route path="/dashboard" element={<SecureRoute><Dashboard /></SecureRoute>} />
                            <Route path="/Visit" element={<SecureRoute><Visit /></SecureRoute>} /> */}
                            {/* <Route
                            path="/dashboard"
                            element={
                                <SecureRoute>
                                <Dashboard />
                                </SecureRoute>
                            }
                            /> */}
                            <Route path="/Visit" element={<Visit />} />
                            <Route path="*" element={<Home onModeChange={handleModeChange}/>} />
                        </Routes>
                        {/* <SecureRoute path="/messages" component={Messages} /> */}
                        {/* <SecureRoute path="/dashboard" component={Dashboard} />
                            <SecureRoute path="/Visit" component={Visit} /> */}

                    {/* <SecureRoute path="/Visit/{token}" component={Visit} /> */}
                    {/* </Switch> */}
                    {/* </Container> */}
                    {/* </PatientContext.Provider> */}
                    {/* </VisitWithPrefContextProvider> */}
                    </ErrorBoundary>
                    </DictionaryContextProvider>
                </CopyUserPrefContextProvider>
            </UserPrefContextProvider>
        </AuthContextProvider>
    </Security>
    // </PatientContext.Provider>
  );
};

export default App;

// /*
//  * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
//  * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
//  *
//  * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
//  * Unless required by applicable law or agreed to in writing, software
//  * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
//  * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//  *
//  * See the License for the specific language governing permissions and limitations under the License.
//  */

// import React from 'react';
// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import { OktaAuth } from '@okta/okta-auth-js';
// import { Security, LoginCallback } from '@okta/okta-react';
// import { Container } from 'semantic-ui-react';
// import config from './config';
// import Dashboard from './pages/Dashboard';
// import Visit from './pages/Visit';
// // import Navbar from './ui/components/Navbar';
// import NavbarEnlighten from './ui/components/NavbarEnlighten';
// // import userPreference from './userPreference';
// // import AdministrativeActions from './ui/components/footer/AdministrativeActions';

// const oktaAuth = new OktaAuth(config.oidc);

// const App = () => (
//   <Router>
//     <Security oktaAuth={oktaAuth}>
//       {/* <Navbar /> */}
//       <NavbarEnlighten />
//       {/* <userPreference /> */}
//       <Container text style={{ marginTop: '7em' }}>
//         <Switch>
//           <Route path="/" exact component={Dashboard} />
//           <Route path="/callback" component={LoginCallback} />
//           <Route path="/Visit">
//             <Visit />
//           </Route>
//         </Switch>
//       </Container>
//     </Security>
//   </Router>
// );
// export default App;
